import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prepareWord'
})
export class PrepareWordPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    if(value.toLowerCase() !== 'undefined' && value.toLowerCase() !== 'null'){
      return value ? value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
    }
    return '';
  }

}
